import { component } from 'picoapp';
import app from 'app';  // eslint-disable-line
import Drawer from 'utils/drawer';
import CartForm from 'lib/cart-form';

export default component((node, ctx) => {
  /**
   * Data + elements
   */
  const config = JSON.parse(node.dataset.config);
  const { cartDrawerDisabledClass, termsPopupActiveClass } = config;
  const cartDrawer = Drawer(node);
  const cartForm = new CartForm(node, { termsPopupActiveClass });

  /**
   * Functions
   */
  const open = () => {
    cartDrawer.open();
  };

  const close = () => {
    cartDrawer.close();
  };

  const initCloseBtn = () => {
    const closeBtn = node.querySelector('.js-closeBtn');
    closeBtn.addEventListener('click', close);
  };

  const update = (markup) => {
    node.innerHTML = markup;
    app.mount();
    initCloseBtn();
    cartForm.initTerms();
    open();
  };

  const disable = () => {
    node.classList.add(cartDrawerDisabledClass);
  };

  const enable = () => {
    node.classList.remove(cartDrawerDisabledClass);
  };

  const init = () => {
    ctx.on('cart:open', open);
    ctx.on('cart:updated', ({ cartDrawerMarkup }) => update(cartDrawerMarkup));
    ctx.on('cart:disable', disable);
    ctx.on('cart:enable', enable);

    initCloseBtn();
    cartForm.initTerms();
  };

  /**
   * Init
   */
  init();
});
